import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { MHColours } from '../../constants/theme';
import mhSymbol from '../../../public/image/mh_symbol.svg';

interface BrandProps {
  name: string;
  iconWidth?: number;
}

const Brand: React.FC<BrandProps> = ({ name, iconWidth = 20 }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
    {/* Decorative: the name next to it already says what it is. */}
    <Box
      component="img"
      src={mhSymbol}
      alt=""
      sx={{ display: 'block', width: iconWidth, height: 'auto', flex: 'none' }}
    />
    <Typography
      sx={{
        fontFamily: 'inherit',
        fontWeight: 700,
        fontSize: 13.5,
        color: MHColours.mhDeepTeal,
        whiteSpace: 'nowrap',
      }}
    >
      {name}
    </Typography>
  </Box>
);

export default Brand;
